var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useProfileContext } from '@marketing/profile/ProfileContext';
import PetPurchasingMotivationsInput from '@marketing/profile/common/PetPurchasingMotivationsInput';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { trackAddPurchasingMotivations } from '@marketing/profile/trackers';
import { useState } from 'react';
import { useNavigate } from 'react-router';
var PetPurchasingMotivationsForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, currentPet = _a.currentPet, currentPetIndex = _a.currentPetIndex, currentPetSurvey = _a.currentPetSurvey, updateCurrentPetSurvey = _a.updateCurrentPetSurvey, saveProfile = _a.saveProfile, sendFunnelGTMEvent = _a.sendFunnelGTMEvent, setFacebookSubscribeEventProps = _a.setFacebookSubscribeEventProps, profileBasePath = _a.profileBasePath;
    var _b = useState(currentPetSurvey.purchasingMotivations || []), purchasingMotivations = _b[0], setPurchasingMotivations = _b[1];
    var handlePurchasingMotivationsChange = function (newSelections) {
        setPurchasingMotivations(newSelections);
        updateCurrentPetSurvey({ purchasingMotivations: newSelections });
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/health"), { viewTransition: true });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newPetSurveys, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    updateCurrentPetSurvey({ purchasingMotivations: purchasingMotivations });
                    newPetSurveys = profileData.petSurveys.map(function (survey, index) {
                        if (index === Number(currentPetIndex)) {
                            return __assign(__assign({}, survey), { purchasingMotivations: purchasingMotivations });
                        }
                        return survey;
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({ petSurveys: newPetSurveys })];
                case 2:
                    data = _a.sent();
                    trackAddPurchasingMotivations(data, setFacebookSubscribeEventProps);
                    sendFunnelGTMEvent('click-next_issues');
                    navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/health_concerns"), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formId = 'pet-purchasing-motivations-form';
    return (_jsx(ProfileFormLayout, __assign({ formId: formId, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Your Dog\u2019s Dietary Concerns" }, { children: _jsx("form", __assign({ id: formId, onSubmit: handleSubmit }, { children: _jsx(PetPurchasingMotivationsInput, { handlePurchasingMotivationsChange: handlePurchasingMotivationsChange, petName: currentPet.name, purchasingMotivations: purchasingMotivations }) })) })) })));
};
export default PetPurchasingMotivationsForm;
